// Жетоны фермы по снабжению: ключ текстуры поля farm_<остаток>_<лимит> — и картинка, общая у
// поля и панели снабжения. Пути литеральные: их переписывает scripts/versionTokenArt.js
export const FARM_TOKEN_IMAGES = {
  farm_0_1: '/img/hexes/farm.699e6dfc.png',
  farm_1_1: '/img/hexes/farm 1_1.3a45c526.png',
  farm_0_2: '/img/hexes/farm 0_2.370d7e0c.png',
  farm_1_2: '/img/hexes/farm 1_2.94531de2.png',
  farm_2_2: '/img/hexes/farm 2_2.ff00b6a9.png',
};

/**
 * @param {number} remaining - сколько снабжения на ферме еще не роздано
 * @param {number} capacity - сколько она дает за фазу
 * @returns {string} картинка: столько колосков, сколько дает ферма, белые — еще не розданные
 */
export const getFarmTokenImage = (remaining, capacity) => FARM_TOKEN_IMAGES[`farm_${remaining}_${capacity}`];
